<section class="content public-registration-status">
  <div class="content-block">
    <div class="status-shell">
      <div class="status-hero card">
        <div class="status-hero__badge">SEGUIMIENTO DE FOLIO</div>

        <div class="status-hero__icon-wrap">
          <div class="status-hero__icon">
            <mat-icon>fact_check</mat-icon>
          </div>
        </div>

        <div class="status-hero__copy">
          <div class="status-title">CONSULTA TU SOLICITUD</div>
          <div class="status-subtitle">INGRESA TU FOLIO PARA VER EL ESTATUS ACTUAL DE TU REGISTRO.</div>
        </div>
      </div>

      <div class="status-card card">
        <form [formGroup]="form" class="status-form" autocomplete="off">
          <div class="status-form__layout">
            <div class="status-form__field">
              <mat-form-field appearance="outline" class="example-full-width no-uppercase">
                <mat-label>FOLIO</mat-label>
                <input formControlName="folio" matInput />
              </mat-form-field>
              <div *ngIf="form.get('folio')?.touched && form.get('folio')?.hasError('required')" class="custom-error-below custom-error-below--status">
                <small class="text-danger">EL FOLIO ES OBLIGATORIO.</small>
              </div>
            </div>

            <div class="status-form__action">
              <button class="button-custom" mat-button color="primary" [disabled]="loading" (click)="search()">
                <mat-icon>search</mat-icon>
                {{ loading ? 'CONSULTANDO...' : 'CONSULTAR' }}
              </button>
            </div>
          </div>
        </form>

        <div class="loading-state" *ngIf="loading">
          <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate"></mat-progress-spinner>
        </div>

        <div class="status-result" *ngIf="!loading && result">
          <div class="status-result__header">
            <div>
              <div class="result-label">FOLIO</div>
              <div class="result-value">{{ result.folio }}</div>
            </div>

            <span class="status-chip" [ngClass]="statusClass">{{ result.estatus }}</span>
          </div>

          <div class="detail-grid">
            <div><strong>TIPO:</strong> {{ result.tipoSolicitud }}</div>
            <div><strong>ULTIMA ACTUALIZACION:</strong> {{ result.fechaModificacionUtc | date:'yyyy-MM-dd HH:mm' }}</div>
            <div><strong>FECHA DE REGISTRO:</strong> {{ result.fechaCreacionUtc | date:'yyyy-MM-dd HH:mm' }}</div>
            <div><strong>FECHA DE APROBACION:</strong> {{ result.fechaAprobacionUtc ? (result.fechaAprobacionUtc | date:'yyyy-MM-dd HH:mm') : 'N/D' }}</div>
            <div class="full-row" *ngIf="result.motivoRechazo"><strong>MOTIVO DE RECHAZO:</strong> {{ result.motivoRechazo }}</div>
            <div class="full-row" *ngIf="result.comentarios"><strong>COMENTARIOS:</strong> {{ result.comentarios }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
